module.exports = __webpack_public_path__ + "media/vid_installation.f8a71cb2.mp4";